"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Level;
(function (Level) {
    Level["H1"] = "+h1";
    Level["H2"] = "+h2";
    Level["H3"] = "+h3";
    Level["H4"] = "+h4";
})(Level || (Level = {}));
exports.Heading = function (props) {
    var content = props.content;
    var Tag;
    switch (props.level) {
        case Level.H1:
            Tag = "h1";
            break;
        case Level.H2:
            Tag = "h2";
            break;
        case Level.H3:
            Tag = "h3";
            break;
        case Level.H1:
        default:
            Tag = "h4";
    }
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays(["c-heading", props.level], utilityClasses);
    return react_1.default.createElement(Tag, { className: classes.join(" ") }, content !== null && content !== void 0 ? content : props.children);
};
exports.Heading.Level = Level;
//# sourceMappingURL=Heading.js.map